import React from "react";
import { journeySteps } from "../mock";

export default function Journey() {
  return (
    <section id="journey" className="py-24 bg-gray-50 relative overflow-hidden">
      <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-brand-light" />
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto">
          <div className="section-label justify-center mb-4">Our Recruitment Journey</div>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-gray-900 spaced-heading leading-tight">
            From <span className="text-brand">Certification</span> to Career Placement
          </h2>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-5 gap-6">
          {journeySteps.map((j, i) => (
            <div key={j.id} className="relative bg-white border border-gray-100 rounded-2xl p-6 card-hover">
              <div className="w-14 h-14 rounded-full bg-brand text-white flex items-center justify-center font-display text-xl font-bold">{j.step}</div>
              <h3 className="mt-5 font-display font-bold text-gray-900 leading-tight">{j.title}</h3>
              <p className="mt-2 text-sm text-gray-600 leading-relaxed">{j.desc}</p>
              {i < journeySteps.length - 1 && (
                <div className="hidden lg:block absolute top-10 -right-3 w-6 h-0.5 bg-brand/30" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
